export const LIMIT = 100;
export const UPLOAD_CONST = '';
export const URI = 'https://ats-api.luhaifdigitech.com';
// export const URI = 'http://localhost:3004';
export const ROLES = ['RECRUITER', 'MANAGER', 'SUPER ADMIN'];
